module.exports = __webpack_public_path__ + "media/stylesheets/images/icon/aside_play-6554ffd0a1db64449aa4274d3a505984.svg";